/* eslint-disable sort-keys */
import React from 'react'
import Organisations from 'view/component/organisations'
import Categories from 'view/component/categories'
import UserTypes from 'view/component/user-types'
import Tags from 'view/component/tags'
import StatusTags from 'view/component/table-columns/status-tags'
import ArticleActions from 'view/component/table-columns/article-actions'
import AttachmentActions from 'view/component/table-columns/attachment-actions'
import DatasetActions from 'view/component/table-columns/dataset-actions'
import DiscoveryActions from 'view/component/table-columns/discovery-actions'
import InsightActions from 'view/component/table-columns/insight-actions'
import OrderActions from 'view/component/table-columns/order-actions'
import WebpageActions from 'view/component/table-columns/webpage-actions'
import { MenuOutlined } from '@ant-design/icons'

const articleActionsColumn = {
  key: 'action',
  width: 100,
  render: article => {
    const action = <ArticleActions article={article} />
    return action
  },
  title: 'Actions'
}

const attachmentActionsColumn = {
  key: 'action',
  width: 100,
  render: attachment => {
    const action = <AttachmentActions attachment={attachment} />
    return action
  },
  title: 'Actions'
}

const discoveryActionsColumn = {
  key: 'action',
  width: 100,
  render: discovery => {
    const action = <DiscoveryActions discovery={discovery} />
    return action
  },
  title: 'Actions'
}

const datasetActionsColumn = {
  key: 'action',
  width: 100,
  render: dataset => {
    const action = <DatasetActions dataset={dataset} />
    return action
  },
  title: 'Actions'
}

const insightActionsColumn = {
  key: 'action',
  width: 100,
  render: insight => {
    const action = <InsightActions insight={insight} />
    return action
  },
  title: 'Actions'
}

const webpageActionsColumn = {
  key: 'action',
  width: 100,
  render: webpage => {
    const action = <WebpageActions webpage={webpage} />
    return action
  },
  title: 'Actions'
}

const orderActionColumn = {
  key: 'action',
  width: 100,
  render: category => {
    const action = (<OrderActions
      category={category}
      subCategory={category.sub_categories}
                    />)
    return action
  }
}
const statusColumn = {
  key: 'status',
  width: 100,
  render: ({ published, is_draft: isDraft, pinned }) => {
    const component = (
      <StatusTags
        draft={isDraft}
        pinned={pinned}
        published={published}
      />
    )
    return component
  },
  title: 'Status'
}

const titleColumn = {
  dataIndex: 'title',
  key: 'title',
  sorter: true,
  title: 'Title',
  width: 250
}

const shortDescriptionColumn = {
  dataIndex: 'short_description',
  key: 'short_description',
  title: 'Introduction',
  width: 500
}

const userTypesColumn = {
  dataIndex: 'user_types',
  key: 'user_types',
  render: (userTypes) => {
    const component = <UserTypes userTypes={userTypes} />
    return component
  },
  title: 'User Type Permissions',
  width: 250
}

const tagsColumn = {
  dataIndex: 'tags',
  key: 'tags',
  render: (tags) => {
    const component = <Tags tags={tags} />
    return component
  },
  title: 'Tags',
  width: 250
}

const organisationsColumn = {
  dataIndex: 'organisations',
  key: 'organisations',
  render: (organisations) => {
    const component = <Organisations organisations={organisations} />
    return component
  },
  title: 'View Permissions',
  width: 500
}

const categoryColumn = {
  dataIndex: 'category',
  key: 'category',
  render: (categories) => {
    const component = <Categories categories={categories} />
    return component
  },
  title: 'Category',
  width: 200
}

// const subCategoryColumn = {
//   dataIndex: 'sub_category',
//   key: 'sub_category',
//   render: ({ name }) => name,
//   title: 'Sub Category',
//   width: 200
// }

const updateFrequencyColumn = {
  dataIndex: 'update_frequency',
  key: 'update_frequency',
  title: 'Update Frequency',
  width: 200
}

const nameColumn = {
  dataIndex: 'name',
  key: 'name',
  title: 'Name'
}

const createdColumn = {
  dataIndex: 'created',
  key: 'created',
  title: 'Created',
  width: 200
}

const modifiedColumn = {
  dataIndex: 'modified',
  key: 'modified',
  title: 'Modified',
  width: 200
}

const documentColumn = {
  dataIndex: 'file_name',
  key: 'file_name',
  title: 'Document',
  width: 200
}

const fileSizeColumn = {
  dataIndex: 'file_size',
  key: 'file_size',
  title: 'File size',
  width: 200
}

const fileTypeColumn = {
  dataIndex: 'file_extension',
  key: 'file_extension',
  title: 'File type',
  width: 200
}

const sortColumn = {
  title: 'Sort',
  dataIndex: 'sort',
  width: 100,
  key: 'order',
  className: 'drag-visible',
  render: (text, record, index) => (
    <a
      className='drag-handle'
      href='#'
    >
      <MenuOutlined
        style={{
          color: '#999',
          cursor: 'grab'
        }}
      />
    </a>)
}
export const articleColumns = {
  action: articleActionsColumn,
  status: statusColumn,
  title: titleColumn,
  short_description: shortDescriptionColumn,
  user_types: userTypesColumn,
  organisations: organisationsColumn,
  category: categoryColumn,
  update_frequency: updateFrequencyColumn,
  created: createdColumn,
  modified: modifiedColumn
}

export const datasetColumns = {
  action: datasetActionsColumn,
  status: statusColumn,
  title: titleColumn,
  short_description: shortDescriptionColumn,
  user_types: userTypesColumn,
  tag_uuid: tagsColumn,
  organisations: organisationsColumn,
  category: categoryColumn,
  update_frequency: updateFrequencyColumn,
  created: createdColumn,
  modified: modifiedColumn
}

export const discoveryColumns = {
  action: discoveryActionsColumn,
  status: statusColumn,
  title: titleColumn,
  short_description: shortDescriptionColumn,
  user_types: userTypesColumn,
  tag_uuid: tagsColumn,
  organisations: organisationsColumn,
  category: categoryColumn,
  created: createdColumn,
  modified: modifiedColumn
}

export const insightColumns = {
  action: insightActionsColumn,
  status: statusColumn,
  title: titleColumn,
  short_description: shortDescriptionColumn,
  user_types: userTypesColumn,
  tag_uuid: tagsColumn,
  organisations: organisationsColumn,
  category: categoryColumn,
  update_frequency: updateFrequencyColumn,
  created: createdColumn,
  modified: modifiedColumn
}

export const webpageColumns = {
  action: webpageActionsColumn,
  status: statusColumn,
  title: titleColumn,
  short_description: shortDescriptionColumn,
  user_types: userTypesColumn,
  tag_uuid: tagsColumn,
  organisations: organisationsColumn,
  category: categoryColumn,
  update_frequency: updateFrequencyColumn,
  created: createdColumn,
  modified: modifiedColumn
}

export const attachmentColumns = {
  action: attachmentActionsColumn,
  file_name: documentColumn,
  file_type: fileTypeColumn,
  created: createdColumn,
  user_types: userTypesColumn,
  file_size: fileSizeColumn
}

export const orderCategoriesColumns = {
  order: sortColumn,
  name: nameColumn,
  action: orderActionColumn
}
